module.exports = __webpack_public_path__ + "static/assets/143a9041098d0e0724ed22c89e6558cc.svg";